import { MouseEvent } from 'react';
import { ReactComponent as Star } from '@packages/shared/assets/star.svg';
import discount from '@packages/shared/assets/experts-catalogue/discount.png';
import Image from '@packages/shared/core/common/components/common/Image';
import { Expert } from '@packages/shared/core/experts/entities';
import Button from '@packages/shared/core/common/components/common/Button';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import styles from './ExpertCatalogueMobile.module.scss';

export type ExpertCatalogueMobileProps = {
  info: Expert;
  onStartChat: (event: MouseEvent) => void;
  onExpertClick: () => void;
  price?: string;
  discountText?: string;
};

const maxSloganLength = 80;

const ExpertCatalogueMobile = ({
  onStartChat,
  info,
  onExpertClick,
  price = '$3/min',
  discountText = 'Get 10 min for $1.99',
}: ExpertCatalogueMobileProps) => {
  return (
    <div role="button" onClick={onExpertClick} className={styles.container}>
      <div className={styles.info}>
        <div className={styles.imageWrapper}>
          <Image
            src={info.image}
            className={styles.image}
            alt="expert"
            objectFit="cover"
            layout="fixed"
            width={80}
            height={80}
          />
        </div>

        <div className={styles.personalInfo}>
          <p className={styles.name}>{info.name}</p>

          <p className={styles.slogan}>{info.slogan.slice(0, maxSloganLength)}...</p>
        </div>
      </div>

      <div className={styles.awards}>
        <div>
          <p className={styles.rating}>
            {info.rating}

            {` `}

            <Star />
          </p>

          <p className={styles.review}>Based on {info.review_count} reviews</p>
        </div>

        <div>
          <div className={styles.discount}>
            <Image src={discount} layout="fill" alt="discount" />

            <p className={styles.discountText}>{discountText}</p>
          </div>

          <p className={styles.price}>{price}</p>
        </div>
      </div>

      <Button
        data-testid={DataTestId.START_CHAT_BUTTON}
        wrapperClassName={styles.buttonWrapper}
        className={styles.button}
        onClick={onStartChat}
      >
        Start chat
      </Button>
    </div>
  );
};

export default ExpertCatalogueMobile;
